var XPortal = XPortal || {};
XPortal.Account = (function () {
    var self = { Name: null, };

    self.Init = function (c) {
        var stel = $(c ? c : "body").find(".account-state");
        var $accountContainer = $('.auth__container');
        if (stel.length > 0) {
            var accountInfo = JSON.parse(stel.attr("data-info"))
            self.Name = accountInfo.name;
            self.DbName = accountInfo.dbname;
            self.MemberName = accountInfo.membername;
            self.CNames = (accountInfo.cname ? accountInfo.cname : "").split(",");
            self.userTimeZoneOffset = Number.parseInt(accountInfo.tzOffset);
            //if TimeZone is not set in user profile - will be used local system offset by default
            self.calculatedTimeZoneOffset = isNaN(self.userTimeZoneOffset) ? 0 : ((new Date().getTimezoneOffset() * -1) - self.userTimeZoneOffset) * -1;
            self.userTimeZoneOffsetSrv = Number.parseInt(accountInfo.tzOffsetServer);
            self.userTimeZoneUseDST = accountInfo.tzUseDST;
            self.dataFormats = accountInfo.dataFormats;
            self.NameLCaseE = accountInfo.name_encr ? accountInfo.name_encr.toLowerCase() : "";
            self.NameLCase = accountInfo.name ? accountInfo.name.toLowerCase() : "";
        }
        if (XPortal.inputHandler && $accountContainer.length > 0) XPortal.inputHandler.Init($($accountContainer));
        self.setEvents();
        self.initActOnBeHalf();
        self.initActOnBeHalfExpiredModal();
    };
    self.IsSame = function (x) {
        var xvals = _.isArray(x) ? x : [x];
        var found = false;
        var r = xvals.find(function (ik) {
            ikx = ik ? ik.toLowerCase() : "";
            return found = (self.NameLCase == ikx || self.NameLCaseE == ikx);
        });
        return found;
    };

    self.setEvents = function () {
        $(document).on('click', 'button.btn-confirm-popup', function () {
            var $btn = $(this);
            var $cblock = $btn.parent().find('.confirmation');

            var modalParams = {
                options: {
                    showModal: true,
                    headerText: $cblock.find('[data-modal-title]').text(),
                    confirmationText: $cblock.find('[data-modal-content]').text(),
                    buttonsText: [$btn.attr('data-btn-cancel'), $btn.attr('data-btn-confirm')]
                }
            };

            XPortal.Modal.confirm(modalParams, function (r) {
                if (r.result == 'yes') {
                    var $cbtn = $($btn.attr('data-confirmed'));
                    $cbtn.trigger('click');
                };
            });
        }).on('keypress', '#login-form-container input.form-control', function (e) {
            // if (e.keyCode == 13) { 
            // e.preventDefault();
            // $(this).closest('form').find('.btn').click();
            // }
        });

        $(document).on("click", ".login-via-network-btn", function () {
            var el = $(this);
            var frm = el.closest("form").parent().find(".ex-logings-form");
            frm.find(".loginprovider").val(el.val());
            frm[0].submit();
        });
    };

    self.IsAuthenticated = function () {
        const accountInfo = XPortal.Utils.readJsonStr($('.profile.account-state').attr("data-info"), null);
        if (!accountInfo) return false;
        let loginName = accountInfo.name;
        let isLogin = loginName ? loginName.length : 0;
        if (!isLogin) return false;
        return true;
    }

    self.ShowFinalConfirmPopup = function (selector, cback) {
        var $cblock = $(selector);

        var modalParams = {
            headerText: $cblock.find('[data-modal-title]').html(),
            alertText: $cblock.find('[data-modal-content]').html()
        };

        XPortal.Modal.alert(modalParams, cback ? cback() : function () {
            window.location.href = window.location.href;
        });
    };

    self.PersonalData = {
        Export: function (selector, options) {
            var container = $(selector);
            XPortal.Main.InitEditControls(container);
            if (container.length == 0) container = $(".account-export-block .apdata-downloader");
            if (container.length == 0) return null;

            XPortal.Loader.show({ 'selector': null, showOverlay: true });
            if (options && options.startWith) {//render member data as well
                var rm = [];
                for (var i in options.startWith.model)
                    rm.push({ field: i, value: options.startWith.model[i] });
                var pgoptions = {
                    dataSource: { data: { "items": rm }, schema: { data: "items" } },
                    columns: [{ field: "field", title: "" }, { field: "value", title: "" }]
                };
                if (options.startWith.options) pgoptions = $.extend(true, pgoptions, options.startWith.options, pgoptions);
                $(options.startWith.selector).kendoGrid(pgoptions);
            }
            var gridContainers = container.find(".grid-parent");
            waitFor(function () {
                var grids = _.filter(_.map(gridContainers.find(".k-grid"), function (xi) { return $(xi).data("kendoGrid"); }), function (xi) { return xi != null; });
                if (grids.length != gridContainers.length) return false;
                setTimeout(function () { exportAllPersonalData(grids, options); }, 1000);
                return true;
            }, waitFor);
        }
    };

    self.InitCountDown = function (cntr, opts) {
        cntr.find(".jscountdown-cntr").remove();
        var jscoundown = $("<div class=\"jscountdown-cntr\" style='margin: 0 auto;width:60px;position: relative;top:50%;transform: translateY(-50 %);'/>").appendTo(cntr);
        opts = Object.assign({
            radius: 30, seconds: 180, fontColor: '#000', autostart: false, onComplete: function () {
                countdown.start(new Date());
                window.location.href = window.location.href;
            }
        }, opts || {});
        var countdown = jscoundown.countdown360(opts);
        jscoundown.on("stop-countdown", function () {
            countdown.stop();
        });
        if (countdown && countdown.start) countdown.start(new Date());//todo ajust tostart from token generation time    
    };
    function exportAllPersonalData(grids, options) {
        var r = $.Deferred();
        var progress = 0, dp = grids.length;
        var dstart = new Date();
        var xmessage = function (p, mp, pp) {
            var diffsec = (new Date() - dstart) / 1000;
            progress = progress + (p - pp) / (mp * dp);
            var percComplete = progress > 1 ? 100 : progress * 100;
            var secleft = Math.max((100 * diffsec) / percComplete - diffsec, 0);
            var tLeft = secleft > 60 ? '~' + Math.ceil(secleft / 60) + 'min' : '~' + Math.ceil(secleft / 60) + 'sec';
            var ttip = '' + Math.ceil(percComplete) + '% complete\r\ntime left:' + tLeft;
            XPortal.Loader.message({ 'selector': null, showOverlay: true }, '' + Math.ceil(percComplete) + '%', ttip);
            return diffsec;
        };
        var alldatapromises = _.map(grids, function (gi) {
            var xp = 0;
            return exportPersonalData(gi, {
                columns: gi.columns, dataSource: gi.dataSource, allPages: false, filterable: true, hierarchy: false,
                pageIndex: 0, pageSize: gi.dataSource.pageSize(), pagesAmount: gi.dataSource.totalPages(), joinPages: true,
                message: function (p, mp) {
                    var r = xmessage(p, mp, xp);
                    xp = p;
                    return r;
                }
            });
        });
        $.when.apply(this, alldatapromises).done(function () {
            var wbooks = arguments;
            XPortal.Loader.hide({ 'selector': null, showOverlay: true });
            if (wbooks.length > 0) {
                var fbook = { sheets: [] };
                var snames = [];
                for (var i = 0; i < wbooks.length; i++) {
                    var ibook = wbooks[i];
                    var msheets = ibook.sheets.length > 1;
                    while (ibook.sheets.length > 0) {
                        var isheet = ibook.sheets.pop();
                        var sheetSuff = msheets ? "_" + isheet.name : "";
                        var sname = isheet.name = (ibook.fileName ? ibook.fileName : "data_" + i).replace(".xlsx", "") + sheetSuff;
                        var sindex = 1;
                        while (_.find(snames, function (si) { return si == sname; }) != null)
                            sname = isheet.name + '_' + (sindex++);
                        snames.push(sname);
                        isheet.name = sname;
                        fbook.sheets.push(isheet);
                    }
                }
                var bookXml = new kendo.ooxml.Workbook(fbook);
                saveAs(bookXml.toDataURL(), 'data.xlsx');
                window.location.href = window.location.href;
            }
        });
    };

    function exportPersonalData(griddata, ots) {
        var r = $.Deferred();
        var excel = griddata.options.excel;
        excel.allPages = false;
        excel.fileName = getfileNameforExport(griddata);
        var exporter = new XPortal.ExcelExporter(ots);
        exporter.workbook().then($.proxy(function (book) {
            book.fileName = book.fileName || excel.fileName;
            book._options = ots;
            r.resolve(book);
        }, this));
        return r.promise();
    }

    function getfileNameforExport(griddata) {
        var gname = "";
        if (griddata.options && griddata.options.pageData) {
            gname = griddata.options.pageData.title;
            gname = gname ? gname : griddata.options.pageData.name;
        }
        if (gname && gname.length > 0) return gname;
        var parent = griddata.element.closest(".grid-parent");
        if (parent.length > 0) {
            var $title = parent.find(".original-title");
            var original = $title.attr('data-original-title') ? $title.attr('data-original-title') : "";
            var viewtitle = $title.attr('data-current-title') ? $title.attr('data-current-title') : "";
            return (original.length > 0 ? original : "Grid") + (viewtitle.length > 0 ? "-" + viewtitle : "");
        }
        return "Grid";
    }

    function waitFor(onAction, onFalse) {
        if (!onAction()) {
            setTimeout(function () { onFalse(onAction, onFalse); }, 100);
        }
    }

    self.memberActonbehalfData = null;

    self.initActOnBeHalf = function () {
        var $dataInput = $("#members-data-hidden");
        if (!$dataInput.length)
            return;

        self.memberActonbehalfData = JSON.parse($dataInput.val());
        $dataInput.remove();
        if (self.memberActonbehalfData && self.memberActonbehalfData.members && self.memberActonbehalfData.members.length)
            self.SetLoginStateName(self.memberActonbehalfData.members.find(item => item.memberId == self.memberActonbehalfData.selected));
    };
    self.initActOnBeHalfExpired = function () {
        const $element = $(XPortal.Modal.modalSelector + " .continue-representation-modal-content");
        if (!$element.length) return;
        const sttgs = XPortal.Utils.readJsonStr($element.attr("data-sttgs") || "{}", {});
        $element.attr("data-sttgs", "");

        $element.off('click').on('click', '.btn, button.close', e => {
            const ael = $(e.currentTarget);
            const actionName = ael.attr('data-action');

            if (actionName && actionName == 'continue') {                
                const memberId = sttgs.selected;
                saveMemberOnBehalf(memberId)
                    .always(() => {
                        HideActOnBehalfModal();
                    });
                self.SetLoginStateName(self.memberActonbehalfData.members.find(e => e.memberId == memberId));
            }
            if (actionName && actionName == 'end') {
                saveMemberOnBehalfMyself()
                    .always(() => {
                        HideActOnBehalfModal();
                        const $loginStateName = $("#login-state-name");
                        const originName = $loginStateName.attr("origin-name");
                        if (originName)
                            $loginStateName.html(originName);
                    });
            }
        });
    };

    self.initActOnBeHalfExpiredModal = function () {
        const superRepresentationTemplate = $('#continue-representation-modal-template');
        if (superRepresentationTemplate.length) {
            XPortal.Modal.prepareModalFromTemplate('#continue-representation-modal-template');
            self.initActOnBeHalfExpired();
        }
    };

    self.initGridOnModalDialog = function () {
        var $element = $(XPortal.Modal.modalSelector + " .member-actonbehalf-content");
        if (!$element.length)
            return;

        let memberNameTitle = $element.find(".member-name-title").text();
        let memberEmailTitle = $element.find(".member-email-title").text();
        var $memberGrid = $element.find(".member-grid");

        $memberGrid.kendoGrid({
            dataSource: {
                data: self.memberActonbehalfData.members
            },
            height: 200,
            selectable: true,
            columns: [{
                field: "memberId",
                title: "Member Id",
                hidden: true
            }, {
                field: "memberName",
                title: memberNameTitle
            }, {
                field: "memberEmail",
                title: memberEmailTitle
            }],
            change: function (e) {
                $element.find('.save-member-ob').removeAttr('disabled', 'disabled').removeClass('disabled');
            }
        });

        // $memberGrid.find(".k-grid-content").css("height", "370px");

        $element.find('.save-member-ob').click(function () {
            let item = GetSelectedMember($element);
            let memberId = item.memberId;
            saveMemberOnBehalf(memberId)
                .always(function () {
                    HideActOnBehalfModal();
                });
            self.SetLoginStateName(item);
        });

        $element.find(".act-as-myself").click(function () {
            saveMemberOnBehalfMyself()
                .always(function () {
                    HideActOnBehalfModal();
                    let $loginStateName = $("#login-state-name");
                    let originName = $loginStateName.attr("origin-name");
                    if (originName)
                        $loginStateName.html(originName);
                });
        });

        var tmtIndex = 0;
        $element.find('.quick-search-modal').on("keydown", function (e) {
            var $input = $(this);
            clearTimeout(tmtIndex);
            if (e.which == 13)
                QuickSearchModal($element, $input);
            else
                tmtIndex = setTimeout(function () {
                    QuickSearchModal($element, $input);
                }, 10);
        });

        SelectMemberById($element, self.memberActonbehalfData.selected);
    };

    self.SetLoginStateName = function (item) {
        if (!item)
            return;

        let $loginStateName = $("#login-state-name");
        let additionalTitle = $loginStateName.attr("additional-title");
        let originName = $loginStateName.attr("origin-name");
        let name = originName !== item.memberName ? item.memberName : originName;
        $loginStateName.html(additionalTitle + " " + name).attr('title', name).addClass('font-weight-bold').addClass('font-italic');
    };

    self.ShowActOnBehalfModal = function () {
        XPortal.Modal.prepareModalFromTemplate('#member-modal-template');
        self.initGridOnModalDialog();
    };

    self.LocalizeDateTime = function (cdateTime) {
        var curTimeAsUtc = moment(cdateTime).add(-1 * cdateTime.getTimezoneOffset(), "m").utc();
        var resTzOffset = XPortal.Utils.getMemberTzOffset(self);
        var res = curTimeAsUtc.add(-1 * resTzOffset, "m");
        return res.toDate();
    };

    function SelectMemberById($element, memberId) {
        let el = $element.find(".member-grid");
        let grid = el.data("kendoGrid");
        let item = grid.dataSource.data().find(item => item.memberId == memberId);
        if (!item) {
            $element.find('.save-member-ob').attr('disabled', 'disabled').addClass('disabled');
        } else {
            let rowIndex = grid.dataSource.data().indexOf(item);
            var rows = el.find("tbody > tr");
            grid.select(rows[rowIndex]);
        }
    }

    function GetSelectedMember($element) {
        let entityGrid = $element.find(".member-grid").data("kendoGrid");
        let selectedItem = entityGrid.dataItem(entityGrid.select());
        return selectedItem;
    }

    function HideActOnBehalfModal() {
        var $companyModal = $(XPortal.Modal.modalSelector);
        $companyModal.modal('hide');
        window.location.reload(false);
    }

    function QuickSearchModal($element, $quickSearch) {
        let value = "";
        if ($quickSearch.length > 0) {
            value = $quickSearch[0].value;
        }

        let ds = $element.find(".member-grid").data("kendoGrid").dataSource;
        let newfilter = {
            logic: "or",
            filters: [
                { field: "memberName", operator: "contains", value: value },
                { field: "memberEmail", operator: "contains", value: value }
            ]
        };

        ds.filter(newfilter, ds.options);
        $element.find('.save-member-ob').attr('disabled', 'disabled').addClass('disabled');
    }

    function saveMemberOnBehalf(memberId) {
        var postData = {
            model: { MemberId: memberId }
        };
        return $.ajax({
            url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/Member/SaveMemberOnBehalf"),
            type: 'POST', dataType: 'json',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: postData
        });
    }

    function saveMemberOnBehalfMyself() {
        return XPortal.Utils.APIPost("/umbraco/Surface/Member/SaveMemberOnBehalfMyself", null);
    }

    return self;
}());

